import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { toast } from 'react-toastify';
import images from '../assets/images';
import TermsAndConditionModal from '../pages/terms-conditions/TermsAndConditionModal';
import { getTermAndCondition, saveTermsAndCondition } from '../services/login/loginApi-service';
import type { AppState } from '../store/state/app.state';
import type { ITermsConditionModalState } from '../types/stateTypes';
import { companyNameReplace } from '../utils';

const AuthLayout = () => {
  const userData = useSelector((state: AppState) => state.UserData);

  const [termsModal, setTermsModal] = useState<ITermsConditionModalState>({
    showModal: false,
    body: '',
    callBack: null,
  });

  const isTermsAndConditionRequired = userData?.terms_and_condition_required;

  useEffect(() => {
    fetchData();
  }, []);

  const closeModal = () => {
    setTermsModal({
      showModal: false,
      body: '',
      callBack: null,
    });
  };

  const fetchData = async () => {
    if (isTermsAndConditionRequired) {
      const response = await getTermAndCondition();
      setTermsModal({
        showModal: true,
        body: response.Data.content,
        callBack: () => saveTermsAndConditions(response.Data.id),
      });
    }
  };

  const saveTermsAndConditions = async (termsAndConditionId: number) => {
    try {
      const input = {
        terms_conditions: [{ id: termsAndConditionId, accepted: true }],
      };
      await saveTermsAndCondition(input);
      closeModal();
    } catch (error) {
      toast.error(error.response?.message || error.toString());
    }
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="login-page container-fluid p-0">
        <div className="row h-100 no-gutters">
          <div className="col-md login-background-block">
            <a href="#" title={companyNameReplace(t<string>('login.label.logo'))} className="instavolt-logo">
              <img src={images.logoPNG} alt={companyNameReplace(t<string>('login.label.logo'))} />
            </a>
          </div>
          <div className="col-md-auto login-section">
            <div className="auth-outer">
              <Outlet />
            </div>
          </div>
        </div>
        {termsModal.showModal && (
          <TermsAndConditionModal modal={termsModal} isShowCloseButton={false} isShowAccceptButton={true} />
        )}
      </div>
    </>
  );
};

export default AuthLayout;
